// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-539cc7f4] .vxe-toolbar {\n  height: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
